module.exports = __webpack_public_path__ + "zvetseni-prsou_18_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_18_after.jpg
// module id = 1309
// module chunks = 0